import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { useEffect, useState } from "react";
import Errors from "../../models/errors";
import Subcompany, { newSubcompany } from "../../models/subcompany";
import SubcompanyForm from "./SubcompanyForm";

interface SubcompanyUpdateModalProps {
  show: boolean;
  subcompany?: Subcompany;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const SubcompanyUpdateModal: React.FC<SubcompanyUpdateModalProps> = ({
  show,
  subcompany,
  onCancel,
  onSuccess,
}) => {
  const [initialErrors, setInitialErrors] = useState<Errors>({});
  const [initialSubcompany, setInitialSubcompany] = useState<Subcompany>(
    subcompany ? subcompany : newSubcompany()
  );

  const modalTitle = subcompany
    ? `Editar Sub Organización: ${subcompany.name}`
    : `Crear Sub Organización nueva`;

  const onClose = () => {
    setInitialErrors({});
    setInitialSubcompany(newSubcompany());
    onCancel();
  };
  useEffect(() => {
    setInitialSubcompany(subcompany ? subcompany : newSubcompany());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subcompany]);

  return (
    <CModal show={show} onClose={onClose} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <SubcompanyForm
            initialSubcompany={initialSubcompany}
            initialErrors={initialErrors}
            onCancel={onCancel}
            onSuccess={onSuccess}
          />
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default SubcompanyUpdateModal;
